import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {ApiService} from '../../services/api/api.service';
import {FormatService} from '../../services/format/format.service';
import * as moment from 'moment';

// midtrans payment types → label + icon (brand hue lives in the icon only)
const PAYMENT_VW: any = {
  gopay:         {label: 'GoPay',         icon: 'fa fa-wallet',          color: '#00AED6'},
  bank_transfer: {label: 'Transfer Bank', icon: 'fa fa-university',      color: '#7c8db5'},
  echannel:      {label: 'E-Channel',     icon: 'fa fa-money-check-alt', color: '#7c8db5'},
  akulaku:       {label: 'Akulaku',       icon: 'fa fa-shopping-bag',    color: '#E7364D'},
  qris:          {label: 'QRIS',          icon: 'fa fa-qrcode',          color: '#303e67'},
  credit_card:   {label: 'Kartu Kredit',  icon: 'fa fa-credit-card',     color: '#1761fd'},
};

const STATUS_LABEL: any = {
  settlement: 'Berhasil',
  pending: 'Menunggu',
  failed: 'Gagal',
  expire: 'Kedaluwarsa',
};

@Component({
  selector: 'app-sahamqu',
  templateUrl: './sahamqu.component.html',
  styleUrls: ['./sahamqu.component.css']
})
export class SahamquComponent implements OnInit {
  isData: any = [];
  isTotalAll: number = 0;
  isKeyword: string = '';
  isStatus: string = '';

  isPage: number = 1;
  isPageSize: number = 10;
  isPages: any = [];
  isTableLoading: boolean = false;

  constructor(
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.getData();
  }

  private searchTimer: any;
  private lastQuery: string = '';

  onKeywordInput(value: string) {
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    // debounce: wait 450ms after the last keystroke before hitting the API
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter() {
    clearTimeout(this.searchTimer);
    const query = `${this.isKeyword}|${this.isStatus}`;
    if (query === this.lastQuery) { return; } // query unchanged, skip the request
    this.lastQuery = query;
    this.isPage = 1;
    await this.getData();
  }

  async getData() {
    let searchData = {"keyword": this.isKeyword, "status": this.isStatus};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try {
      this.apiService.methodGetSilent(`sahamqu/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`, this.authService.getToken()).subscribe((response) => {
        this.isTableLoading = false;
        if (response && response.status == 200) {
          this.isData = [];
          (response.total ? response.data.forEach((element: any) => {
            // relations can be null — must never break the render
            element.userName = element.user ? element.user.name : '-';
            element.nominalVw = this.formatService.currency(element.nominal || 0);
            element.payment = element.payment_method
              ? (PAYMENT_VW[element.payment_method] || {label: element.payment_method, icon: '', color: ''})
              : null;
            element.statusVw = STATUS_LABEL[element.status] || element.status || '-';
            element.createdVw = element.createdAt ? moment(element.createdAt).locale('id').format("D MMMM YYYY HH:mm") : '-';
            this.isData.push(element);
          }) : false);
          this.isTotalAll = response.total || 0;
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    } catch (error) {
      this.isTableLoading = false;
      console.log(error);
    }
  }

  totalPages() {
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager() {
    const total = this.totalPages();
    const pages: any[] = [];
    for (let p = 1; p <= total; p++) {
      if (p == 1 || p == total || Math.abs(p - this.isPage) <= 1) {
        pages.push(p);
      } else if (pages[pages.length - 1] != '...') {
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any) {
    const total = this.totalPages();
    if (p < 1 || p > total || p == this.isPage) { return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number) {
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom() {
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo() {
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  formatNumber(value: any) {
    return this.formatService.dotFormat(value || 0);
  }

  // wrap keyword matches in <mark> for the list; input is HTML-escaped first
  highlight(text: any) {
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if (!keyword) { return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // neutralize regex metacharacters
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  // '-' fallback in one place instead of mutating the source data
  dash(value: any) {
    return (value === null || value === undefined || value === '') ? '-' : value;
  }
}
